import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from "@mui/icons-material/Close";
import ScheduleIcon from "@mui/icons-material/Schedule";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import SyncIcon from "@mui/icons-material/Sync";
import SendIcon from "@mui/icons-material/Send";
import { Drawer } from "@mui/material";
import {
  formatDateReadable,
  formatTimestampDateReadable,
} from "../../utilities/helpers";
import DrawerHeader from "../helpers/DrawerHeader";
import DrawerFooterContainerSmall from "../helpers/DrawerFooterContainerSmall";
import ButtonFilledCancel from "../helpers/ButtonFilledCancel";
import StatusWithText from "../helpers/StatusWithText";
import PillAvailability from "../helpers/PillAvailability";
import ModalUserStatusCard from "../helpers/ModalUserStatusCard";
import ModalAvailabilityCard from "../helpers/ModalAvailabilityCard";
import ModalInfoCard from "../helpers/ModalInfoCard";

export default function DefaultAvailabilityCardUpdated(props) {
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleRescindSubmit = () => {
    props.rescind_availability_request(props.id);
    setDrawerOpen(false);
  };


  return (
    <>
      <div
        className={`flex flex-col ${props.status !== "current" ? "cursor-pointer" : ""}`}
        onClick={props.status !== "current" ? toggleDrawer(true) : undefined}
      >
        <div
          className={`w-full h-16 rounded-xl flex flex-col justify-center px-4 shadow relative ${
            props.availability
              ? props.availability === "All Day"
                ? `bg-green-200 ${props.status !== "current" ? "hover:bg-green-300" : ""}`
                : props.availability === "Unavailable"
                ? `bg-red-200 ${props.status !== "current" ? "hover:bg-red-300" : ""}`
                : props.availability === "No Availability Set"
                ? `bg-slate-100 ${props.status !== "current" ? "hover:bg-slate-200" : ""}`
                : `bg-amber-200 ${props.status !== "current" ? "hover:bg-amber-300" : ""}`
              : `bg-slate-100 ${props.status !== "current" ? "hover:bg-slate-200" : ""}`
          }`}
        >
          <h3 className="text-xs font-bold">
            {props.availability ? props.availability : "No Availability Set"}
          </h3>
          {props.availability2 && (
            <h3 className="text-xs font-bold mt-1">{props.availability2}</h3>
          )}
          {props.preferences && (
            <h4 className="text-xxs text-slate-700">
              {"Preferred: " + props.preferences}
            </h4>
          )}
        </div>
      </div>
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <div className="w-[450px] h-screen bg-white relative">
          <div className="max-h-screen overflow-auto">
            <DrawerHeader
              title={`${props.day} Availability Request`}
              onClose={toggleDrawer(false)}
            />

            {/* Scrollable Content */}
            <div className="py-5 px-6">
              {/* Status Card */}
              <div className="mb-6">
                <ModalUserStatusCard
                  status={props.status?.toLowerCase()}
                  name="Your Availability Request"
                  icon={ScheduleIcon}
                />
              </div>

              {/* Day Card */}
              <div className="mb-4">
                <ModalInfoCard
                  icon={CalendarMonthIcon}
                  title="Day"
                  value={props.day}
                />
              </div>

              {/* Availability Card */}
              <div className="mb-4">
                <ModalAvailabilityCard
                  title="Requested Availability"
                  availability={props.availability}
                  availability2={props.availability2}
                  preferences={props.preferences}
                  icon={SyncIcon}
                />
              </div>

              {/* Effective Date Card */}
              {props.inEffect &&
                <div className="mb-4">
                  <ModalInfoCard
                    icon={CalendarTodayIcon}
                    title="Effective Date"
                    value={formatDateReadable(props.inEffect)}
                  />
                </div>
              }

              {/* Note Card */}
              {props.note && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={CreateOutlinedIcon}
                    title="Your Note"
                    value={props.note}
                  />
                </div>
              )}

              {/* Manager Note Card */}
              {props.acting_manager_note && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={CreateOutlinedIcon}
                    title="Manager Note"
                    value={props.acting_manager_note}
                  />
                </div>
              )}

              {/* Date Submitted Card */}
              {props.dateSubmitted && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={SendIcon}
                    title="Date Submitted"
                    value={formatTimestampDateReadable(props.dateSubmitted, props.storeTimezone)}
                  />
                </div>
              )}

              {/* Spacer for footer */}
              <div className="h-[200px]"></div>
            </div>

            {/* Footer */}
            <DrawerFooterContainerSmall>
              {/* Employees can cancel their own pending or approved (upcoming)
                  availability so they can submit a revised one. The backend
                  permits self-rescind of approved availability; only future-
                  dated rows reach this card (current rows aren't clickable). */}
              {(props.status === "pending" || props.status === "approved") && (
                <ButtonFilledCancel
                  text="Cancel Request"
                  onClick={handleRescindSubmit}
                />
              )}
            </DrawerFooterContainerSmall>
          </div>
        </div>
      </Drawer>
    </>
  );
}
